import { GMTooltipPlugin } from '@gm/components'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(GMTooltipPlugin)
})